import { Box, BoxProps } from "@chakra-ui/react";

export function NotificationIcon({
  color = "currentColor",
  ...props
}: BoxProps & { color?: string }) {
  return (
    <Box {...props} color={color}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.00014 1.29175C5.88014 1.29175 3.35441 3.8121 3.35441 6.91675V6.9168C3.35434 7.81883 3.30985 8.83064 2.6719 9.77025L2.6699 9.77318L2.66989 9.77318C2.565 9.9258 2.47293 10.0509 2.38614 10.1688C2.27054 10.3259 2.16432 10.4702 2.04969 10.6498C1.87199 10.9283 1.76178 11.1696 1.72626 11.4024C1.6113 12.156 2.09198 12.7523 2.93272 13.1005C6.49853 14.5777 11.5018 14.5777 15.0676 13.1005C15.9083 12.7523 16.389 12.156 16.274 11.4024L16.8919 11.3081L16.274 11.4024C16.2385 11.1696 16.1283 10.9283 15.9506 10.6498C15.836 10.4702 15.7298 10.3259 15.6142 10.1688C15.5274 10.0509 15.4353 9.9258 15.3304 9.77318L15.3284 9.77025C14.6904 8.83064 14.6459 7.81883 14.6459 6.9168V6.91675C14.6459 3.8121 12.1201 1.29175 9.00014 1.29175ZM2.10441 6.9167C2.10444 3.11781 5.19371 0.041748 9.00014 0.041748C12.8066 0.041748 15.8959 3.11784 15.8959 6.91675H15.2709H15.8959C15.8959 7.80043 15.9552 8.46728 16.3616 9.06673C16.4181 9.14885 16.4931 9.25171 16.575 9.3641C16.7172 9.55935 16.8805 9.78336 17.0043 9.97737C17.2228 10.3198 17.4363 10.7327 17.5097 11.2139C17.7492 12.7836 16.6453 13.8 15.546 14.2554C11.6738 15.8594 6.32644 15.8594 2.45432 14.2554C1.35497 13.8 0.251098 12.7836 0.490559 11.2138C0.563956 10.7327 0.777459 10.3198 0.995991 9.97737C1.11981 9.78335 1.28304 9.55935 1.42532 9.3641C1.50724 9.25168 1.58221 9.1488 1.63872 9.06666C2.04506 8.46724 2.10434 7.80037 2.10441 6.91675"
          fill="#1C00B8"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.50613 14.2294C5.83973 14.1407 6.18204 14.3393 6.27069 14.6729C6.57864 15.8317 7.67435 16.7084 8.99999 16.7084C10.3256 16.7084 11.4213 15.8317 11.7293 14.6729C11.8179 14.3393 12.1603 14.1407 12.4938 14.2294C12.8274 14.318 13.026 14.6603 12.9374 14.9939C12.4812 16.7105 10.8818 17.9584 8.99999 17.9584C7.11818 17.9584 5.51882 16.7105 5.06262 14.9939C4.97397 14.6603 5.17253 14.318 5.50613 14.2294Z"
          fill="#1C00B8"
        />
      </svg>
    </Box>
  );
}

export default NotificationIcon;
